<span *ngIf="color" class="vehicle-color-indicator" [ngStyle]="{'background-color': color}"></span>
